<template>
  <div
    id="unsupported-banner"
    class="unsupported-banner unsupported-banner--browser"
  >
    <div class="unsupported-banner__title">
      {{ translations[language].title }}
    </div>
    <div class="unsupported-banner__description">
      {{ translations[language].description }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from "#app";
import { computed } from "vue";

import type { LocaleMorpheus } from "@solvari/translations";

import { localeToLanguage } from "@solvari/translations";

const props = defineProps<{ locale: LocaleMorpheus }>();

const language = computed(() => localeToLanguage(props.locale));

const translations = {
  fr: {
    title: "Votre navigateur n'est plus supporté :",
    description:
      "Il semble que votre navigateur n'est plus compatible avec notre site web. Par conséquent, certaines fonctionnalités risquent de ne pas fonctionner.",
  },
  nl: {
    title: "Niet langer ondersteunde browser:",
    description:
      "Het ziet ernaar uit dat wij uw browser niet meer ondersteunen. Hierdoor kunnen sommige features niet werken.\n",
  },
  da: {
    title: "Din browser understøttes ikke længere:",
    description:
      "Det ser ud til, at din browser ikke længere er kompatibel med vores hjemmeside. Derfor kan nogle funktioner muligvis ikke fungere.",
  },
  sv: {
    title: "Din webbläsare stöds inte längre:",
    description:
      "Det verkar som att din webbläsare inte längre stöds av vår webbplats. Därför kan vissa funktioner inte fungera.",
  },
};

// This all needs to be inline for maximum browser support
useHead({
  script: [
    {
      type: "text/javascript",
      tagPosition: "bodyClose",
      textContent: `
        var supportedBrowsers = /Edge?\\/(12\\d|1[3-9]\\d|[2-9]\\d{2}|\\d{4,})\\.\\d+(\\.\\d+|)|Firefox\\/(12[1-9]|1[3-9]\\d|[2-9]\\d{2}|\\d{4,})\\.\\d+(\\.\\d+|)|Chrom(ium|e)\\/(12\\d|1[3-9]\\d|[2-9]\\d{2}|\\d{4,})\\.\\d+(\\.\\d+|)|(Maci|X1{2}).+ Version\\/(17\\.([2-9]|\\d{2,})|(1[89]|[2-9]\\d|\\d{3,})\\.\\d+)([,.]\\d+|)( \\(\\w+\\)|)( Mobile\\/\\w+|) Safari\\/|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(17[._]([2-9]|\\d{2,})|(1[89]|[2-9]\\d|\\d{3,})[._]\\d+)([._]\\d+|)|Android.+Firefox\\/(149|1[5-9]\\d|[2-9]\\d{2}|\\d{4,})\\.\\d+(\\.\\d+|)|Android.+Chrom(ium|e)\\/(14[6-9]|1[5-9]\\d|[2-9]\\d{2}|\\d{4,})\\.\\d+(\\.\\d+|)/;
        if (!supportedBrowsers.test(navigator.userAgent)) {
          document.getElementById("unsupported-banner").style.display = "block";
        }`,
    },
  ],
  style: [
    {
      tagPosition: "bodyClose",
      textContent: `
        .unsupported-banner {
          width: 100%;
          text-align: center;
          padding-bottom: 20px;
          padding-top: 20px;
          z-index: 99999;
          background: #9e0505;
          color: #d3d3d3;
          position: fixed;
          bottom: 0;
          left: 0;
        }
        .unsupported-banner--browser {
          display: none;
        }
        .unsupported-banner__title {
          display: block;
          font-size: 32px;
          font-weight: bold;
        }
        .unsupported-banner__description {
          display: block;
          font-size: 18px;
          font-weight: bold;
        }`,
    },
  ],
});
</script>
